var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00488281H513V341.999H0V-0.00488281Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75 126.379C401.175 126.379 414.49 113.064 414.49 96.6395C414.49 80.2146 401.175 66.8995 384.75 66.8995C368.325 66.8995 355.01 80.2146 355.01 96.6395C355.01 113.064 368.325 126.379 384.75 126.379Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.703 89.212H436.786V133.821H332.703V89.212Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.707 200.73V230.47H348.353C357.735 239.664 370.576 245.339 384.75 245.339C398.925 245.339 411.765 239.664 421.147 230.47H436.793V200.73H332.707Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.707 126.383V170.992C332.707 210.828 384.75 223.035 384.75 223.035C384.75 223.035 436.793 210.829 436.793 170.992V126.383H332.707Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.747 150.21C371.737 150.21 371.737 162.106 358.726 162.106C345.716 162.106 345.716 150.21 332.706 150.21V171.027C345.716 171.027 345.716 182.924 358.726 182.924C371.737 182.924 371.737 171.027 384.747 171.027C397.758 171.027 397.758 182.924 410.771 182.924C423.782 182.924 423.782 171.027 436.794 171.027V150.21C423.783 150.21 423.783 162.106 410.771 162.106C397.759 162.105 397.759 150.21 384.747 150.21ZM384.747 108.539C371.737 108.539 371.737 120.435 358.726 120.435C345.716 120.435 345.716 108.539 332.706 108.539V129.356C345.716 129.356 345.716 141.252 358.726 141.252C371.737 141.252 371.737 129.356 384.747 129.356C397.758 129.356 397.758 141.252 410.771 141.252C423.782 141.252 423.782 129.356 436.794 129.356V108.539C423.783 108.539 423.783 120.435 410.771 120.435C397.759 120.435 397.759 108.539 384.747 108.539Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00488281V22.6563L210.341 53.4253H256.5V117.55H210.341L256.5 148.33V170.991H233.828L160.312 121.977V170.991H96.1875V121.977L22.6722 170.991H0V148.33L46.159 117.55H0V53.4253H46.159L0 22.6563V-0.00488281H22.6722L96.1875 48.9976V-0.00488281H160.312V48.9976L233.828 -0.00488281H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.0098877H112.219V69.4595H0V101.522H112.219V170.991H144.281V101.522H256.5V69.4595H144.281V-0.0098877Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0098877V15.1016L57.4891 53.4283H80.1562L0 -0.0098877ZM256.5 -0.0098877V15.1016L199.011 53.4283H176.344L256.5 -0.0098877Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0098877V15.1016L57.4891 53.4283H80.1562L0 -0.0098877ZM256.5 -0.0098877V15.1016L199.011 53.4283H176.344L256.5 -0.0098877ZM0 170.991V155.88L57.4891 117.553H80.1562L0 170.991ZM256.5 170.991V155.88L199.011 117.553H176.344L256.5 170.991Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/KY.2f9d399adceb964985b228f3b052eb62.svg";
export { ForwardRef as ReactComponent };